import { applyMiddleware, createStore, combineReducers } from "redux";
import thunk from "redux-thunk";
import { userReducer } from "../../js/redux/reducers/user";
import {
    blogReducer,
    blogDetailsReducer,
    blogCategoriesReducer,
    blogLatest,
} from "../../js/redux/reducers/blogReducer";

const landingReducers = combineReducers({
    userReducer,
    blogReducer,
    blogDetailsReducer,
    blogCategoriesReducer,
    blogLatest,
});

export const landingStore = createStore(landingReducers, applyMiddleware(thunk));
